import i18n from '@/i18n';
import { branches } from '@/utils/permission';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const Branches = () => import('./views/Index.vue');
const BranchView = () => import('./views/BranchView.vue');

export default [
  {
    path: 'branches',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: `${PREFIX.INSPECTOR}.Branches`,
        component: Branches,
        meta: {
          title: i18n.global.t('branches.branches'),
          permission: { module: branches.module, key: branches.showAll },
        },
      },
      {
        path: 'view/:id?',
        name: `${PREFIX.INSPECTOR}.Branches.View`,
        component: BranchView,
        meta: {
          title: i18n.global.t('branches.view'),
          pageType: 'view',
          permission: { module: branches.module, key: branches.showOne },
        },
        props: true,
      },
      {
        path: 'create',
        name: `${PREFIX.INSPECTOR}.Branches.Create`,
        component: BranchView,
        meta: {
          title: i18n.global.t('branches.create'),
          pageType: 'create',
          permission: { module: branches.module, key: branches.create },
        },
      },
      {
        path: 'update/:id?',
        name: `${PREFIX.INSPECTOR}.Branches.Update`,
        meta: {
          title: i18n.global.t('branches.update'),
          pageType: 'update',
          permission: { module: branches.module, key: branches.update },
        },
        component: BranchView,
        props: true,
      },
    ],
  },
];
